import React, { Component } from 'react';  
import { StyleSheet, Text, View, TouchableOpacity, Animated, ImageBackground, Image, AsyncStorage, I18nManager as RNI18nManager } from 'react-native';  
import store from '../config/config.json';
import { color } from '../config/color';
import { withNavigation } from 'react-navigation';
import i18n from 'i18n-js';
import MainComponent from '../utilities/MainComponent';
import { EventRegister } from 'react-native-event-listeners'
import { rgbToHex, hexToRgb } from '@material-ui/core';

class Main extends MainComponent {  

    state = {
        isShowing: false,
        store: {},
        opacity : new Animated.Value(0)
    }

    constructor(props){
        super(props)
        this.getData()
    }

    getData = async () => {
		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)			
            this.setState({store: value})
            
        } catch (error) {
            console.log(error)
        }
    }        
    
    switchToHome(){
		this.props.navigation.navigate("menu");
	}

	switchToBranches(){
		this.props.navigation.navigate("branches");
	}

	switchToSearch(){
		this.props.navigation.navigate("search");
	}

	switchToStatus(){
		this.props.navigation.navigate("status");
    }

    changeLanguage()
    {
        if(i18n.locale == this.state.store.defaultLanguage)
            i18n.locale = this.state.store.secLanguage
        else
            i18n.locale = this.state.store.defaultLanguage

        if(i18n.locale == 'ar')
        {
            RNI18nManager.forceRTL(true);
        } 
        else
        {
            RNI18nManager.forceRTL(false);
        }   

        this.setState({store: this.state.store})
        EventRegister.emit('languageEvent', 'it works!!!')
        
        //Updates.reloadFromCache();
    }

    render() {  

        var name = this.state.store.name
        var details = this.state.store.details;

        if(i18n.locale != this.state.store.defaultLanguage){
            name    = this.state.store.nameSec
            details = this.state.store.detailsSec
        }

        if(name == undefined || name == "")
            name = this.state.store.name
        if(details == undefined || details == "")
            details = this.state.store.details

        var textLang = this.state.store.defaultLanguage
        if(i18n.locale == this.state.store.defaultLanguage)
            textLang = this.state.store.secLanguage
    
        if(textLang == undefined)
            textLang = ""
        else
            textLang = textLang.toUpperCase()

        var mainBgColor = "rgba(0, 0, 0, 0.5)"

        if(this.state.store.themes != undefined)
        {
            mainBgColor = this.state.store.themes.theme1.bgColor
            var opacity     = this.state.store.themes.theme1.alpha
            mainBgColor = hexToRgb(mainBgColor + Math.round(opacity * 255).toString(16))
        }

        return (  

            <ImageBackground source={this.state.store.bgImageUrl} style={{flex: 1}}>
							
            <View style={{backgroundColor: mainBgColor, flex: 1}} >

            <View style={{alignContent: "center", marginTop: 10, alignItems:"center", justifyContent:"center", flexDirection:"row"}}>

            {this.state.store.secLanguage != undefined && this.state.store.secLanguage != 'none' && (
                <View style={{position: "absolute", flexDirection: "row", width:"100%", justifyContent: "flex-end", height:30}}>
                    <TouchableOpacity style={styles.langButton}
                        onPress={() => { this.changeLanguage() }}
                    >
                        <Text style={{fontFamily:"main-bold", textAlign: "center", color: 'white', fontSize: 16}}>{textLang}</Text>															
                    </TouchableOpacity>
                </View>
            )}	


            <TouchableOpacity style={{marginLeft: 35, height:30, justifyContent: "center"}}
                        onPress={() => { 
                            if(this.props.title != 'Menu')
                                this.switchToHome()
                        }}
                >
					{ this.props.title == 'Menu' &&(<Text style={{ fontFamily: 'main-bold',fontSize:14, color: 'white'}}>{i18n.t('menu')}</Text>)}		
					{ this.props.title != 'Menu' &&(<Text style={{ fontFamily: 'main-bold',fontSize:14, color: color.menuLight}}>{i18n.t('menu')}</Text>)}		
                </TouchableOpacity>

                <TouchableOpacity style={{marginLeft: 35, height:30, justifyContent: "center"}}
                                    onPress={() => {                             
                                        if(this.props.title != 'Search')
                                            this.switchToSearch()
                        }}
                >
					{ this.props.title == 'Search' &&(<Text style={{ fontFamily: 'main-bold',fontSize:14, color: 'white'}}>{i18n.t('search')}</Text>)}		
					{ this.props.title != 'Search' &&(<Text style={{ fontFamily: 'main-bold',fontSize:14, color: color.menuLight}}>{i18n.t('search')}</Text>)}		
                </TouchableOpacity>

                <TouchableOpacity style={{marginLeft: 35, height:30, justifyContent: "center"}}
                                    onPress={() => {                             
                                        if(this.props.title != 'Branches')
                                            this.switchToBranches()
                        }}
                >
					{ this.props.title == 'Branches' &&(<Text style={{ fontFamily: 'main-bold',fontSize:14, color: 'white'}}>{i18n.t('branches')}</Text>)}		
					{ this.props.title != 'Branches' &&(<Text style={{ fontFamily: 'main-bold',fontSize:14, color: color.menuLight}}>{i18n.t('branches')}</Text>)}		
                </TouchableOpacity>

                <TouchableOpacity style={{marginLeft: 35, height:30, justifyContent: "center"}}
                                    onPress={() => {                             
                                        if(this.props.title != 'Status')
                                            this.switchToStatus()
                        }}
                >
					{ this.props.title == 'Status' &&(<Text style={{ fontFamily: 'main-bold',fontSize:14, color: 'white'}}>{i18n.t('orderStatus')}</Text>)}		
					{ this.props.title != 'Status' &&(<Text style={{ fontFamily: 'main-bold',fontSize:14, color: color.menuLight}}>{i18n.t('orderStatus')}</Text>)}		
                </TouchableOpacity>

            </View>

            <View style={{alignContent: "center", alignItems:"center", justifyContent:"center", flex: 1}}>
                <Image source={this.state.store.logoUrl} style={{width: 155, height: 155, overflow:"hidden", borderRadius: 20}}></Image>						
                <Text style={{ fontFamily: 'main-regular',color:'#FFFFFF', marginTop: 10, fontSize:20, fontWeight:'bold', textAlign: 'center'}}>{name}</Text>							
                <Text style={{ fontFamily: 'main-regular',color:'#FFFFFF', marginTop: 10, fontSize:15, fontWeight:'normal', width: "65%", textAlign: 'center'}}>{details}</Text>							
            </View>

            </View>

        </ImageBackground>						
        
        );  
    }  
}  
  
export default withNavigation(Main);

const styles = StyleSheet.create({  
    topBar: {
        flex: 1, 
        height: 54,
        flexDirection: "row", 
        justifyContent: "center", 
        alignContent: "center", 
        alignItems: "center"
    },
    button:{
        height:40, 
        width: 40, 
        justifyContent: "center"
    },
    langButton:{
        alignSelf: "flex-end",
        height:30, 
        width: 40, 
        justifyContent: "center"
    }
})  